<template>
<div>

  <div class="title container align-items-center justify-content-center" style="flex-wrap: wrap;">
    <div class="flex-basis-100 title--mark animation-left animation-delay-01">
      <div class="title--mark-bt" :class="color">
        {{mark}}
      </div>
    </div>

    <div class="flex-grow-1 title--text animation-right animation-delay-03">
      <h1 v-html="value"></h1>
    </div>


    <div class="flex-grow-1 title--text animation-right animation-delay-03 margin-top-10mobile" v-if="titleBtn">
      <div class="flex-basis-100 animation-left animation-delay-01">
        <button type="button" name="button" class="btn btn-md btn-gradient-orange btn-strong btn-full btn-rounded" @click="btnAction()">AGENDAR AULA</button>
      </div>
    </div>

      <div class="flex-grow-1 title--text timer animation-fade animation-delay-2 container justify-content-start align-items-center" v-if="inTime && unitStarted && showTimer">
        <h1 style="line-height: 1;">
          Unit ends in
          <span>{{ date.hours }}</span>h :
          <span>{{ date.minutes > 9 ? date.minutes : `0${date.minutes}` }}</span>m :
          <span>{{ date.seconds > 9 ? date.seconds : `0${date.seconds}` }}</span>s
        </h1>
      </div>
      <div class="title--btn animation-left animation-delay-05" v-if="showOnlineClass" :style="{ marginRight: !button ? 0 : '5px' }">
        <router-link :to="{ name: 'onlineClass' }" style="padding: 5px;" class="btn btn-sm btn-full btn-rounded btn-gradient-orange btn-strong">
          <span class=""> Online Class</span>
        </router-link>
      </div>
      <div class="title--btn animation-left animation-delay-05" v-if="button">
        <router-link :to="{ name: 'book', params: { book: currentBook.title } }" style="padding: 5px;" class="btn btn-sm btn-full btn-rounded btn-gradient-orange btn-strong" v-if="hasBook">
          <span class=""> UNITS</span> <span class="title--btn__plus">+</span>
          <!-- <i style="margin-left: 10px;"class="margin-left-5 fas fa-arrow-right"></i> -->
        </router-link>
        <router-link :to="{ name: 'home' }" class="btn btn-sm btn-full btn-rounded btn-orange btn-strong" v-else>
          Empty Book
        </router-link>
      </div>
      <div class="title--btn animation-left animation-delay-05 container align-items-center" v-if="calendar">
        <div class="title--btn-date container justify-content-between align-items-center">
          <div class="container" style="z-index: 2;">
            <button type="button" name="button" class="btn-month" @click="preMonth()"><img style="transform: rotate(180deg);" class="toprevnext" src="@/assets/img/tonext.svg"></button>
          </div>
          <span class="margin-left-10 margin-right-10" style="width: 155px;">{{ formatedMonth }}</span>
          <div style="z-index: 2;">
            <button type="button" name="button" class="btn-month" @click="nextMonth()"><img class="toprevnext" src="@/assets/img/tonext.svg"></button>
            <!-- <button type="button" name="button" class="btn btn-sm btn-arrow btn-orange" @click="nextMonth()"><i class="fas fa-arrow-right"></i></button> -->
          </div>
        </div>
      </div>

  </div>

</div>
</template>

<script>
import appBus from '@/plugins/appBus'
import i18n from './i18n.js'
import { mapGetters } from 'vuex'
import { dateTimeFormatter, isEqualDateStr } from './tools.js'

const inBrowser = typeof window !== 'undefined'

export default {
  name: 'titleComponent',
  data () {
    return {
      // date: {
      //   hours: 0,
      //   minutes: 0,
      //   seconds: 0
      // },
      interval: null,
      currentDate: Date.now()
    }
  },
  props: {
    value: {
      type: String
    },
    mark: {
      type: String
    },
    color: {
      type: String,
      default: 'background-red'
    },
    button: {
      type: String
    },
    titleBtn: {
      type: Boolean,
      default: false
    },
    calendar: {
      type: Boolean,
      default: false
    },
    btnAction: {
      type: Function,
      default: () => console.log('Button click')
    },
    showTimer: {
      type: Boolean,
      default: false
    },
    showOnlineClass: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    calendarOps () {
      let dateObj = new Date()
      if (inBrowser) {
        return window.VueCalendarBarEventBus.CALENDAR_EVENTS_DATA
      } else {
        return {
          options: {
            locale: 'pt-br',
            color: ' #ff4455'
          },
          params: {
            curYear: dateObj.getFullYear(),
            curMonth: dateObj.getMonth(),
            curDate: dateObj.getUTCDate(),
            curEventsDate: 'all'
          }
        }
      }
    },
    curYearMonth () {
      let tempDate = Date.parse(new Date(`${this.calendarOps.params.curYear}/${this.calendarOps.params.curMonth+1}/01`))
      const date = dateTimeFormatter(tempDate, i18n[this.calendarOps.options.locale].format)
      return date
    },
    formatedMonth () {
      let splitted = this.curYearMonth.split('/')
      switch (parseInt(splitted[0])) {
        case 1:
          splitted[0] = 'January'
          break;
        case 2:
          splitted[0] = 'February'
          break;
        case 3:
          splitted[0] = 'March'
          break;
        case 4:
          splitted[0] = 'April'
          break;
        case 5:
          splitted[0] = 'May'
          break;
        case 6:
          splitted[0] = 'June'
          break;
        case 7:
          splitted[0] = 'July'
          break;
        case 8:
          splitted[0] = 'August'
          break;
        case 9:
          splitted[0] = 'September'
          break;
        case 10:
          splitted[0] = 'October'
          break;
        case 11:
          splitted[0] = 'November'
          break;
        case 12:
          splitted[0] = 'December'
          break;
      }
      return splitted.join(' - ')
    },
    ...mapGetters({
      bookExists: 'book/exists',
      book: 'book/get',
      unitStarted: 'unit/hasStarted',
      inTime: 'unit/inTime',
      date: 'unit/date',
      student: 'student/GET',
      teensBook: 'teens/GET_CURRENT_BOOK',
    }),
    hasBook () {
      if (!this.student.teens)
        return this.bookExists

      return !!this.teensBook
    },
    currentBook () {
      if (!this.student.teens)
        return this.book

      return this.teensBook
    }
  },
  methods: {
    // setToday() {
    //   this.$EventCalendar.toDate(dateTimeFormatter(new Date, i18n[this.calendarOps.options.locale].format))
    // },
    nextMonth() {
      this.$EventCalendar.nextMonth()
      this.$emit('month-changed', this.curYearMonth)
      const month = parseFloat(this.curYearMonth.split('/')[0])
      this.$store.commit('lesson/setCurMonth', month)
    },
    preMonth() {
      this.$EventCalendar.preMonth()
      this.$emit('month-changed', this.curYearMonth)
      const month = parseFloat(this.curYearMonth.split('/')[0])
      this.$store.commit('lesson/setCurMonth', month)
    }
  },
  // mounted () {
  //   this.setToday()
  // }
}
</script>

<style lang="scss" scoped>

.hide_mobile{
  @media (max-width: 440px){
    display: none!important;
  }
}

@media (max-width: 440px) {
  .margin-top-10mobile{
    margin-top: 10px;
  }
}


.title--text.timer {
  // height: 25px;
  padding: 3px 10px;
  margin: 0px 10px;
  border: 2px solid #dfdfdf;
  border-radius: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 440px){
    margin: 10px 0px;
  }
  h1{
    font-size: 17px!important;
    color: #9c9c9c;
    @media (max-width: 440px){
      font-size: 20px;
      padding: 10px;
    }
    span{
      color: #686868;
    }
  }
}

.btn-month{
  height: 23px;
  white-space: nowrap;
  padding: 0px 10px;
  border-radius: 50px;
  background: #ffa500;
  margin: 3px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  outline: none;
  border: none;
  transition: all 0.2s ease-in;

  &:hover{
    background: #632b0f,
    rgba(99, 43, 15, 0.86);
  }
}

.title--btn{
    @media (max-width: 440px){
      // padding: 10px!important;
      width: 100%;
      margin: 10px 0px;
    }
  &__plus{
    margin: 0px 3px;
    font-size: 22px;
    font-weight: 400;
    color: #ffe200;
    @media (max-width: 440px){
      margin: 6px 3px;
    }
  }
  //  @media (max-width: 540px) {
  //    .hide_mobile{
  //      display: none;
  //    }
  // }
}

.toprevnext{
  height: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/titleComponent/index.vue